import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudCheckboxModule,
	FreudDialogModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { UserToggleStatusModalComponent } from './user-toggle-status-modal.component';

@NgModule({
	declarations: [UserToggleStatusModalComponent],
	imports: [
		CommonModule,
		FreudDialogModule,
		TranslateModule,
		FreudButtonModule,
		FreudCheckboxModule,
		FormsModule,
	],
	exports: [UserToggleStatusModalComponent],
	providers: [],
})
export class UserToggleStatusModalModule {}
